var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchAccounts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56066 8.68934C8.97487 8.10355 8.02513 8.10355 7.43934 8.68934C6.85355 9.27513 6.85355 10.2249 7.43934 10.8107C8.02513 11.3964 8.97487 11.3964 9.56066 10.8107C10.1464 10.2249 10.1464 9.27513 9.56066 8.68934ZM10.6213 7.62868C9.44975 6.45711 7.55025 6.45711 6.37868 7.62868C5.20711 8.80025 5.20711 10.6997 6.37868 11.8713C7.55025 13.0429 9.44975 13.0429 10.6213 11.8713C11.7929 10.6997 11.7929 8.80025 10.6213 7.62868Z",
    fill: "#70758F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.041 4.25C3.32821 4.25 2.75 4.82821 2.75 5.541V18.5C2.75 19.1908 3.30921 19.75 4 19.75H20C20.6908 19.75 21.25 19.1908 21.25 18.5V5.5C21.25 4.80921 20.6908 4.25 20 4.25H4.041ZM1.25 5.541C1.25 3.99979 2.49979 2.75 4.041 2.75H20C21.5192 2.75 22.75 3.98079 22.75 5.5V18.5C22.75 20.0192 21.5192 21.25 20 21.25H4C2.48079 21.25 1.25 20.0192 1.25 18.5V5.541Z",
    fill: "#70758F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 9.5C14.25 9.08579 14.5858 8.75 15 8.75H19C19.4142 8.75 19.75 9.08579 19.75 9.5C19.75 9.91421 19.4142 10.25 19 10.25H15C14.5858 10.25 14.25 9.91421 14.25 9.5Z",
    fill: "#70758F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 13.5C14.25 13.0858 14.5858 12.75 15 12.75H17.4C17.8142 12.75 18.15 13.0858 18.15 13.5C18.15 13.9142 17.8142 14.25 17.4 14.25H15C14.5858 14.25 14.25 13.9142 14.25 13.5Z",
    fill: "#70758F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1889 14.7957C5.91448 14.1234 6.86643 13.75 7.85545 13.75H9.14745C10.1364 13.75 11.0882 14.1233 11.8138 14.7954M5.1889 14.7957C4.75964 15.1928 4.42589 15.6801 4.20976 16.2223C4.05638 16.607 4.24396 17.0433 4.62873 17.1967C5.0135 17.3501 5.44975 17.1625 5.60314 16.7777C5.73697 16.442 5.94314 16.1413 6.20775 15.8966L5.69846 15.346L6.20825 15.8961C6.65664 15.4805 7.24458 15.25 7.85545 15.25H9.14745C9.75832 15.25 10.3463 15.4805 10.7947 15.8961L11.3045 15.346L10.7951 15.8966C11.0598 16.1413 11.2659 16.442 11.3998 16.7777C11.5531 17.1625 11.9894 17.3501 12.3742 17.1967C12.7589 17.0433 12.9465 16.607 12.7931 16.2223C12.577 15.6801 12.2432 15.1928 11.8139 14.7956",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchAccounts);
export default __webpack_public_path__ + "static/media/switch-accounts.452f178afb7c99b7e0b857f148ef6033.svg";
export { ForwardRef as ReactComponent };